import React from 'react';
import { Container, IconContainer, Mensagem, Descricao } from './styles';

export default function ListaDemandasVazia() {
  return (
    <Container>
      <IconContainer>
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </IconContainer>
      <Mensagem>Nenhuma demanda encontrada</Mensagem>
      <Descricao>
        Tente ajustar os filtros de busca ou verificar se há demandas cadastradas para o período selecionado.
      </Descricao>
    </Container>
  );
}
